import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getTranslationLanguages, translateDoc } from '../services/apiEndpoints';

export const fetchTranslationLanguage = createAsyncThunk(
  'user/fetchTranslationLanguage',
  async (_, thunkAPI) => {
    try {
      const response = await getTranslationLanguages();
      return JSON.parse(response);
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "An unknown error occurred";
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const translateDocument = createAsyncThunk(
  'user/translateDocument',
  async (payload: any, thunkAPI) => {
    try {
      const response = await translateDoc(payload);
      return response;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "An unknown error occurred";
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

interface ITranslationLanguageState {
    languages: any[];
    targetLanguage: string | undefined;
    error: any | null;
}

const initialState: ITranslationLanguageState = {
    languages: [],
    targetLanguage: undefined,
    error: null
  };

  const translationSlice = createSlice({
    name: 'translation',
    initialState,
    reducers: {
      setTargetLanguage: (state, action) => {
        state.targetLanguage = action.payload;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchTranslationLanguage.fulfilled, (state, action) => {
          state.languages = action.payload;
        })
        .addCase(fetchTranslationLanguage.rejected, (state, action) => {
          state.error = action.payload as string ?? null;
        });
    },
  });

export const { setTargetLanguage } = translationSlice.actions 
export default translationSlice.reducer;